import React from "react";

function NakiNigunArtistUnavailableInAppTemplate() {
    return (
        <p className="u-type--sml u-type--color--warning--light">This artist is not available in mobile application</p>
    );
}

export default NakiNigunArtistUnavailableInAppTemplate;
